import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './FederalLaw.scss';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const variants = {
  fz214: { param: 'fz214', key: 'ФЗ-214', text: i18n.t('components.header.filtersBar.filters.registration.fz214'), event: 'Web_Filters_FZ-214' },
  fz215: { param: 'fz215', key: 'ФЗ-215', text: i18n.t('components.header.filtersBar.filters.registration.fz215'), event: 'Web_Filters_FZ-215' }
};

export const parseSearch = (search) => {
  const { federal_law } = search;
  if (!federal_law) {
    return { federal_law: [] };
  }
  const keys = federal_law.split(',');
  return {
    federal_law: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { federal_law: keys } = data;
  if (!keys.length) {
    return { federal_law: undefined };
  }

  return {
    federal_law: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { federal_law } = data;
  return { federal_law: federal_law.length ? federal_law : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { federal_law: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.federalLaw.notSelected');
};

class FederalLaw extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { federal_law: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const { federal_law: keys } = parseSearch(search);
    const federal_law = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (federal_law.includes(key) !== add) {
      if (add) {
        federal_law.push(key);
      } else {
        federal_law.splice(federal_law.indexOf(key), 1);
      }
    }

    const data = { federal_law };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search } = this.props;
    const { federal_law } = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={federal_law.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variants[key].text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { federal_law } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.federalLaw.title')}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('fz214')}
          </div>
        </div>
        {/* {
            !!federal_law.length &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.federalLaw.clear')}
            </Button>
          } */}
      </div>
    );
  }
}

export default withTranslation()(FederalLaw);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/FederalLaw/FederalLaw.js